import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
import FieldText from '@atlaskit/field-text';
import Form, { Field, Validator } from '@atlaskit/form';
import Lozenge from '@atlaskit/lozenge';
import Modal from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';

// @source
import { crypto } from '../../../../utils';
import { Messages } from '../../../components';
import { Report as API } from '../../../../server';
import { Validation } from '../../../../tools';
import ErrorModal from './ErrorModal';

const initialState = {
  isLoading: false,
  message: false,
};

const initialStatic = {
  report: '',
};

class DuplicateReport extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.static = initialStatic;
    this.unmount = false;
    this.uuid = crypto.decode(this.props.uuid);
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
    this.registerField = this.registerField.bind(this);
  }

  componentWillMount() {
    this.setStatic({
      report: `${this.uuid} - Copy`,
    });
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onSubmitHandle(event) {
    event.preventDefault();
    const validate = this.form.validate();

    if (!validate.isInvalid) {
      this.setState({
        isLoading: true,
        message: false,
      });

      API.duplicate({
        data: {
          report: this.report.Name,
          duplicateReport: this.static.report,
        },
        dispatch: this.props.dispatch,
        success: () => {
          this.props.onClose();
        },
        error: (messages) => {
          this.setStateUnmount({
            isLoading: false,
            message: (
              <Messages
                component="Modal"
                items={messages}
                onClose={() => this.setState({ message: false })}
              />
            ),
          });
        },
      });
    }
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  setStatic(state) {
    this.static = { ...this.static, ...state };
  }

  registerField(node) {
    if (this.form && node) {
      this.form.registerField(node.state.fieldState);
    }
  }

  renderModalBody() {
    return (
      <div>
        <p>
          A new copy will be created, including the entire configuration.
        </p>
        <Field
          name="duplicate-report-field"
          ref={this.registerField}
          validateOnBlur={false}
          validators={[
            Validation.required,
            <Validator
              key="comparison"
              func={value => value !== this.report.Name}
              invalid="Choose a different report name."
              valid="Great!"
            />,
          ]}
        >
          <FieldText
            autoFocus
            onChange={event => this.setStatic({ report: event.target.value })}
            placeholder="Enter new report name"
            shouldFitContainer
            type="text"
            value={this.static.report}
          />
        </Field>
        <p>
          This is:
          <Lozenge>{this.report.Name}</Lozenge>
        </p>
      </div>
    );
  }

  render() {
    this.report = this.props.reports.data.find(item => item.Name === this.uuid);

    if (this.props.reports.override && !this.report) {
      return <ErrorModal onClose={this.props.onClose} />;
    }

    return (
      <Form
        name="duplicate"
        onSubmit={this.onSubmitHandle}
        ref={(form) => { this.form = form; }}
      >
        <Modal
          heading="Duplicate report"
          onClose={this.props.onClose}
          width="small"
          actions={[{
            appearance: 'primary',
            isDisabled: !this.props.reports.override,
            isLoading: this.state.isLoading,
            onClick: this.onSubmitHandle,
            text: 'Duplicate report',
            type: 'submit',
          }, {
            appearance: 'subtle',
            onClick: this.props.onClose,
            text: 'Cancel',
          }]}
        >
          {this.props.reports.override ? this.renderModalBody() : (
            <div style={{ padding: '50px 0', textAlign: 'center' }}>
              <Spinner size="medium" />
            </div>
          )}
          {this.state.message}
        </Modal>
      </Form>
    );
  }
}

DuplicateReport.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  reports: PropTypes.shape().isRequired,
  uuid: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  reports: state.Report,
});

export default connect(mapStateToProps)(DuplicateReport);
